<mat-form-field class="px-4 w-full" [appearance]="appearance" [floatLabel]="floatLabel">
  <mat-label>{{ label }}</mat-label>
  <ng-container matPrefix>
    <ng-content select="[pls-prefix]"></ng-content>
  </ng-container>
  <input
    matInput
    [placeholder]="placeholder"
    [type]="type"
    [value]="value"
    [disabled]='disabled'
    (input)="onInput($event)"
    (blur)="onTouch()"
  />
  <ng-container matSuffix>
    <ng-content select="[pls-sufix]"> </ng-content>
  </ng-container>
</mat-form-field>

<span
  *ngIf="errors; else noError"
  class="px-4 block font-light text-sm text-red-500"
>
  <ng-container *ngIf="msgCustomError">{{ msgCustomError }}</ng-container>
  <ng-container *ngIf="control?.errors?.['required'] && !msgCustomError">{{
    msgRequired
  }}</ng-container>
  <ng-container *ngIf="control?.errors?.['minlength'] && !msgCustomError">
    {{ msgMinlength.replace('{requiredLength}', this.control.errors?.['minlength']?.['requiredLength']) }}
  </ng-container>
  <ng-container
    *ngIf="control?.errors?.['pattern'] && !msgCustomError && !control?.errors?.['maxlength'] && !control?.errors?.['minlength']"
  >
    {{ msgPattern }}
  </ng-container>
</span>

<ng-template #noError>
  <span class="block pb-[14px]"></span>
</ng-template>
